var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.874,
    height: 124.266,
    viewBox: "0 0 158.874 124.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.245,123.393a61.7,61.7,0,1,0-61.54-61.7A61.618,61.618,0,0,0,78.245,123.393Z",
    transform: "translate(4.973)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.871,98.584c-8.791.248-19.44,0-26.87-.124-7.429.124-18.078.372-26.87.124a24.779,24.779,0,0,0,11.02-14.276,42.794,42.794,0,0,0,1.238-5.959H84.612a23.294,23.294,0,0,0,1.238,5.959A24.408,24.408,0,0,0,96.871,98.584Z",
    transform: "translate(13.341 24.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.439,94H100.75",
    transform: "translate(12.805 29.765)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.171,84.308H51.6a42.792,42.792,0,0,0,1.238-5.959H82.056A27.8,27.8,0,0,0,83.171,84.308Z",
    transform: "translate(16.021 24.809)",
    fill: "#84a2ff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.235,95.6a26.556,26.556,0,0,0,7.058-11.3,42.8,42.8,0,0,0,1.238-5.959H83.754a23.293,23.293,0,0,0,1.238,5.959,24.779,24.779,0,0,0,11.02,14.276",
    transform: "translate(14.324 24.809)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.709,20.481V96.7a3.2,3.2,0,0,1-3.219,3.228H25.1A3.282,3.282,0,0,1,21.878,96.7V20.481A3.282,3.282,0,0,1,25.1,17.254H128.49A3.283,3.283,0,0,1,131.709,20.481Z",
    transform: "translate(6.611 5.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.709,37.861V96.7a3.2,3.2,0,0,1-3.219,3.228H25.1A3.282,3.282,0,0,1,21.878,96.7V20.481A3.282,3.282,0,0,1,25.1,17.254H128.49a3.283,3.283,0,0,1,3.219,3.228v9.931",
    transform: "translate(6.611 5.463)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.971,68.638H21.878",
    transform: "translate(6.611 21.734)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.384,68.638h-.867",
    transform: "translate(23.913 21.734)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.194,77.588a2.731,2.731,0,1,0-2.724-2.731A2.728,2.728,0,0,0,64.194,77.588Z",
    transform: "translate(19.148 22.839)",
    fill: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.036,26.327a1.614,1.614,0,1,0-1.61-1.614A1.612,1.612,0,0,0,29.036,26.327Z",
    transform: "translate(8.368 7.314)",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.986,26.327a1.614,1.614,0,1,0-1.61-1.614A1.612,1.612,0,0,0,32.986,26.327Z",
    transform: "translate(9.619 7.314)",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.936,26.327a1.614,1.614,0,1,0-1.61-1.614A1.612,1.612,0,0,0,36.936,26.327Z",
    transform: "translate(10.869 7.314)",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.319,28.379H24.041V79.027h22.04v-49.9h80.238Z",
    transform: "translate(7.296 8.986)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.254,37.99a2.731,2.731,0,1,0-2.724-2.731A2.728,2.728,0,0,0,33.254,37.99Z",
    transform: "translate(9.351 10.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,40.086H27.011a.621.621,0,0,1,0-1.241H42.117a.586.586,0,0,1,.619.621A.8.8,0,0,1,41.993,40.086Z",
    transform: "translate(8.04 12.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,43.009H27.011a.621.621,0,0,1,0-1.241H42.117a.586.586,0,0,1,.619.621A.8.8,0,0,1,41.993,43.009Z",
    transform: "translate(8.04 13.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,45.931H27.011a.621.621,0,0,1,0-1.241H42.117a.586.586,0,0,1,.619.621A.8.8,0,0,1,41.993,45.931Z",
    transform: "translate(8.04 14.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,48.854H27.011a.621.621,0,0,1,0-1.241H42.117a.586.586,0,0,1,.619.621A.8.8,0,0,1,41.993,48.854Z",
    transform: "translate(8.04 15.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,51.777H27.011a.621.621,0,0,1,0-1.241H42.117a.586.586,0,0,1,.619.621A.8.8,0,0,1,41.993,51.777Z",
    transform: "translate(8.04 16.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.812,54.73H26.887a.533.533,0,0,1-.5-.5v-.372a.533.533,0,0,1,.5-.5h7.925a.533.533,0,0,1,.5.5v.372A.533.533,0,0,1,34.812,54.73Z",
    transform: "translate(8.04 16.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.189,19.959a19,19,0,0,1-.371,3.724v.248a17.243,17.243,0,0,1-10.525,11.917c-.248.124-.5.124-.619.248a16.157,16.157,0,0,1-5.448.869A17.144,17.144,0,0,1,95.138,19.835,16.932,16.932,0,0,1,112.1,2.828,17.143,17.143,0,0,1,129.189,19.959Z",
    transform: "translate(29.809 0.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.113,20.316a17.776,17.776,0,0,1-.371,3.6v.248a16.439,16.439,0,0,1-9.905,11.421c-.248.124-.371.124-.62.248a14.3,14.3,0,0,1-5.2.869,16.325,16.325,0,1,1,16.1-16.386Z",
    transform: "translate(30.017 1.284)",
    fill: "#ea67a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.25,3.206a16.932,16.932,0,0,1,15.726,16.883,19,19,0,0,1-.371,3.724v.248a16.627,16.627,0,0,1-10.4,11.793c-.248.124-.5.124-.619.248a15.457,15.457,0,0,1-5.325.869A16.878,16.878,0,0,1,101.735,6.93",
    transform: "translate(29.898 1.015)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,4.893c.5-.248.991-.5,1.61-.745",
    transform: "translate(32.012 1.314)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.649,49.97h-5.7V63.749h5.7Z",
    transform: "translate(14.234 15.823)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.276,45.161h-5.7v20.11h5.7Z",
    transform: "translate(17.599 14.3)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,49.97h-5.7V63.749h5.7Z",
    transform: "translate(20.964 15.823)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.53,37.807h-5.7V67.6h5.7Z",
    transform: "translate(24.33 11.972)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.157,44.879h-5.7V65.361h5.7Z",
    transform: "translate(27.695 14.211)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.649,58.078h-5.7v3.1h5.7Z",
    transform: "translate(14.234 18.39)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.276,57.041h-5.7V61.51h5.7Z",
    transform: "translate(17.599 18.062)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,58.078h-5.7v3.1h5.7Z",
    transform: "translate(20.964 18.39)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.53,55.344h-5.7v6.7h5.7Z",
    transform: "translate(24.33 17.525)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.157,56.947h-5.7V61.54h5.7Z",
    transform: "translate(27.695 18.032)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,67.1a19.243,19.243,0,0,1-5.82-1.117,1.884,1.884,0,0,1,1.114-3.6c3.343,1.117,7.305,1.986,10.773-1.862l.991-1.117c4.458-4.841,7.058-7.7,15.23-3.228,6.563,3.724,8.915,2.359,11.516-1.862a51.437,51.437,0,0,0,2.476-5.338C87.847,45.5,89.209,41.9,92.923,42.4h.248c3.591.372,7.925.869,13.373-6.7a15.444,15.444,0,0,1,2.1-2.483,1.843,1.843,0,0,1,2.476,2.731,9.917,9.917,0,0,0-1.61,1.986C102.953,47.117,96.638,46.5,92.8,46.124h-.248c-.867-.124-1.61,1.49-2.6,4.221A35.9,35.9,0,0,1,87.228,56.3c-3.962,6.579-8.791,7.448-16.468,3.228-5.572-3.1-6.315-2.234-10.649,2.483l-.991,1.117A11.544,11.544,0,0,1,50.2,67.1Z",
    transform: "translate(13.326 10.359)",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.839,36.211H46.286a.993.993,0,0,1,0-1.986h7.553a.993.993,0,0,1,0,1.986Z",
    transform: "translate(14.026 10.837)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.649,39.888H46.286a.993.993,0,0,1,0-1.986H60.649a.978.978,0,0,1,.991.993A1.067,1.067,0,0,1,60.649,39.888Z",
    transform: "translate(14.026 12.002)",
    fill: "#c9daff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.968,68.312a17.688,17.688,0,0,1-.743,5.214A18.345,18.345,0,0,1,23.6,86.188a19.185,19.185,0,0,1-3.839.372,18.248,18.248,0,1,1,18.2-18.248Z",
    transform: "translate(0.179 15.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.86,67.926a20.051,20.051,0,0,1-.743,5.462A19.209,19.209,0,0,1,24,86.546a20.45,20.45,0,0,1-3.962.372,18.993,18.993,0,0,1,0-37.986A19.024,19.024,0,0,1,38.86,67.926Z",
    transform: "translate(0.03 15.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.968,68.312a17.688,17.688,0,0,1-.743,5.214A18.345,18.345,0,0,1,23.6,86.188a19.185,19.185,0,0,1-3.839.372,18.248,18.248,0,1,1,18.2-18.248Z",
    transform: "translate(0.179 15.853)",
    fill: "#84a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.641,49.593A18.89,18.89,0,0,1,38.766,67.717a20.051,20.051,0,0,1-.743,5.462A19.209,19.209,0,0,1,23.907,86.338a20.45,20.45,0,0,1-3.962.372A18.969,18.969,0,0,1,1,67.717,19.218,19.218,0,0,1,13.135,49.965",
    transform: "translate(0 15.704)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85,49.274c.5-.124.991-.124,1.486-.248",
    transform: "translate(3.752 15.524)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.314,63.542h1.733a.586.586,0,0,1,.619.621v6.207a.586.586,0,0,1-.619.621H18.314a.586.586,0,0,1-.619-.621V64.163A.586.586,0,0,1,18.314,63.542Z",
    transform: "translate(5.287 20.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.365,65.9H16.1a.586.586,0,0,1,.619.621v3.1a.586.586,0,0,1-.619.621H14.365a.586.586,0,0,1-.619-.621v-3.1A.586.586,0,0,1,14.365,65.9Z",
    transform: "translate(4.036 20.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.415,67.785h1.734a.586.586,0,0,1,.619.621v.621a.586.586,0,0,1-.619.621H10.415a.586.586,0,0,1-.619-.621v-.621A.586.586,0,0,1,10.415,67.785Z",
    transform: "translate(2.785 21.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,58.952a.533.533,0,0,1,.5.5v3.228a.267.267,0,0,1-.248.248H21.96a.267.267,0,0,1-.248-.248V61.435a38.828,38.828,0,0,1-11.639,7.7H9.825L9.7,69.007V67.89a.267.267,0,0,1,.248-.248,35.294,35.294,0,0,0,10.773-7.324H19.36a.267.267,0,0,1-.248-.248v-.993a.267.267,0,0,1,.248-.248Z",
    transform: "translate(2.755 18.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.915,18.533h-5.7a.533.533,0,0,1-.5-.5v-5.71a.929.929,0,0,0-.743-.869h-.124a7.022,7.022,0,0,0,1.98,13.9,6.844,6.844,0,0,0,5.943-5.959.842.842,0,0,0-.866-.869Z",
    transform: "translate(32.252 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2,11.143v5.586a.585.585,0,0,0,.619.621h5.572a.585.585,0,0,0,.619-.621,6.877,6.877,0,0,0-6.191-6.207c-.248-.124-.619.124-.619.621Z",
    transform: "translate(34.262 3.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.141,94H142.688",
    transform: "translate(4.794 29.765)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademics);
export default __webpack_public_path__ + "static/media/academics.830fd61bc8807c8ddf7a6434d507d981.svg";
export { ForwardRef as ReactComponent };